
import {
  ClassroomModel,
  ListModel,
  QuestionModel,
  ReplyModel,
  UserModel,
} from '@descomplica/dex-models';
import RevisionResultHeader from '../components/RevisionResultHeader.vue';
import RevisionResultContent from '../components/RevisionResultContent.vue';
import RevisionNavbar from '../components/RevisionNavbar.vue';
import { Icon } from '@descomplica/vue-components';
import Vue from 'vue';
import SentryClient from '@/helpers/sentry';
import { UndergradGradesService, UserListActivityStatus } from '@/services/UndergradGrades';

interface Data {
  revision: ListModel | null;
  listStatus: UserListActivityStatus | null;
}

export default Vue.extend({
  components: {
    RevisionNavbar,
    RevisionResultHeader,
    RevisionResultContent,
    Icon,
  },
  data(): Data {
    return {
      revision: null,
      listStatus: null,
    };
  },
  computed: {
    title(): String {
      return this.revision ? this.revision.name : '';
    },
    user(): UserModel {
      return this.$store.getters.currentUser;
    },
    questions(): QuestionModel[] {
      return this.revision ? this.revision.questions : [];
    },
    classroomSlug(): String {
      return this.$router && this.$route.params.classroomSlug;
    },
    correctCounter(): Number {
      let correct = 0;
      this.questions.forEach((question: QuestionModel) => {
        if (this.isQuestionCorrect(question)) correct += 1;
      });

      return correct;
    },
    incorrectCounter(): Number {
      let incorrect = 0;
      this.questions.forEach((question: QuestionModel) => {
        if (this.isQuestionCorrect(question) === false) incorrect += 1;
      });

      return incorrect;
    },
    currentClassroom(): ClassroomModel {
      return this.$store.getters.classroomBySlug(this.$route.params.classroomSlug);
    },
    showDueDateWarning(): boolean {
      return this.$store.getters.isUndergraduateCourse && this.$store.getters.showDueDateWarning;
    },
  },
  async mounted() {
    await this.$store.dispatch('PULL_REVISION_LISTS', {
      userId: this.$store.getters.currentUser.id,
      classroomSlug: this.$route.params.classroomSlug,
    });

    await this.$store.dispatch('PULL_REVISION_LIST_ITEMS', {
      listSlug: this.$route.params.revisionSlug,
    });
    this.revision = this.$store.getters.listBySlug(this.$route.params.revisionSlug);

    if (this.showDueDateWarning) {
      await this.loadReviewListStatus();
    }
  },
  methods: {
    getUserQuestionReply(question: QuestionModel): ReplyModel | null {
      if (!question) return null;

      const replies =
        question.replies &&
        question.replies.filter((reply: ReplyModel) => reply.questionId === question.id);

      if (!replies || !replies.length) {
        return null;
      }

      const mostRecentReply = replies.reduce((reply1: ReplyModel, reply2: ReplyModel) => {
        const date1 = new Date(reply1.createdAt as string);
        const date2 = new Date(reply2.createdAt as string);
        return date1.getTime() > date2.getTime() ? reply1 : reply2;
      });

      return mostRecentReply;
    },
    isQuestionCorrect(question: QuestionModel): Boolean {
      if (!question) return false;

      const reply = this.getUserQuestionReply(question);
      if (!reply || !reply.id || !reply.questionId || !reply.assertionId) return false;

      return !!reply?.isCorrect();
    },
    async loadReviewListStatus() {
      try {
        if (!this.revision?.id) return;

        const listStatusResponse = await new UndergradGradesService().getListStatus(
          this.currentClassroom.id,
          this.revision?.id,
        );

        this.listStatus = listStatusResponse?.reviewLists ?? null;
      } catch (error) {
        SentryClient.captureError(error);
      }
    },
  },
});
